import React from 'react';
import moment from 'moment';

export interface IServicesContext {
  departureDateMin: moment.Moment;
  departureDateMax: moment.Moment;
  setCurrentDepartureDates: (departureDates: moment.Moment[]) => void;
  sortedInfo?: any;
  filteredInfo?: any;
  setSortedInfo: (sortedInfo: any) => void;
  setFilteredInfo: (filteredInfo: any) => void;
}

export const servicesContextInitialState: IServicesContext = {
  departureDateMin: moment(),
  departureDateMax: moment(),
  setCurrentDepartureDates: () => {},
  sortedInfo: undefined,
  filteredInfo: undefined,
  setSortedInfo: () => {},
  setFilteredInfo: () => {},
};

export const ServicesContext = React.createContext<IServicesContext>(
  servicesContextInitialState,
);

export const useServicesContext = (): IServicesContext => {
  const [sortedInfo, _setSortedInfo] = React.useState(
    servicesContextInitialState.sortedInfo,
  );
  const [filteredInfo, _setFilteredInfo] = React.useState(
    servicesContextInitialState.filteredInfo,
  );

  const setSortedInfo = React.useCallback((sortedInfo: any): void => {
    _setSortedInfo(sortedInfo);
  }, []);
  const setFilteredInfo = React.useCallback((filteredInfo): void => {
    _setFilteredInfo(filteredInfo);
  }, []);

  const [departureDates, setDepartureDates] = React.useState({
    departureDateMin: servicesContextInitialState.departureDateMin,
    departureDateMax: servicesContextInitialState.departureDateMax,
  });

  const setCurrentDepartureDates = React.useCallback(
    (departureDates: moment.Moment[]): void => {
      setDepartureDates({
        departureDateMin: departureDates[0],
        departureDateMax: departureDates[1],
      });
    },
    [],
  );

  return {
    ...departureDates,
    setCurrentDepartureDates,
    sortedInfo,
    filteredInfo,
    setSortedInfo,
    setFilteredInfo,
  };
};
